// extracted by mini-css-extract-plugin
module.exports = {"row":"Member_row__bSx4l","noPadding":"Member_noPadding__3KAUE","text":"Member_text__tROeu","email":"Member_email__QnDaR","title":"Member_title__byAXl","name":"Member_name__F9cPz"};